export default "__VITE_ASSET__BdxrsGax__"